export default __webpack_public_path__ + "static/media/illustration_dashboard.d7618d38.png";